import {Helmet} from 'react-helmet-async';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Sets document.title reliably under React 18 (react-helmet alone does not).
 */
export default class DocumentTitle extends React.Component {
  syncTitle(){
    const {title} = this.props;
    if(typeof document !== 'undefined' && title && document.title !== title){
      document.title = title;
    }
  }

  componentDidMount(){
    this.syncTitle();
  }

  componentDidUpdate(prevProps){
    if(prevProps.title !== this.props.title){
      this.syncTitle();
    }
  }

  render(){
    return (
      <Helmet>
        <title>{this.props.title}</title>
      </Helmet>
    );
  }
}

DocumentTitle.propTypes = {
  title: PropTypes.string.isRequired,
};
